import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import * as ExitScreenLayouts from "../components/ExitScreenLayout";
import { ExitScreenLayoutComponent } from "../components/ExitScreenLayout/ExitScreenLayoutTypes";

import useExitScreenPosts from "../../helpers/useExitScreenPosts";

const ExitScreenPage: React.FC = () => {

    const exitScreenPosts = useExitScreenPosts();

    const [searchParams] = useSearchParams();

    const ExitScreenLayout: ExitScreenLayoutComponent = useMemo(() => {
        if (searchParams.has("_exT"))
            //@ts-expect-error
            return ExitScreenLayouts?.[(searchParams.get('_exT')?.toString())] ?? ExitScreenLayouts['default'];

        return ExitScreenLayouts['default'];
    }, [searchParams]);

    document.title = `Polecane artykuły ${window.APP_SETTINGS.domain}`;

    return (
        <ExitScreenLayout posts={exitScreenPosts} />
    );

};

export default ExitScreenPage;